import { PerformancePeriod } from '../models/performance-period.model';

export class AddPerformancePeriods {
    static readonly type = '[PerformancePeriod] AddPerformancePeriods';

    constructor(public payload: PerformancePeriod[]) {}
}
